import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../css/OlympicStatusTeamLeaderCell.css";

/**
 * Team leader name + green/red tick (shared by Status Paris 2024 and Status LA 2028).
 */
function OlympicStatusTeamLeaderCell({ entries }) {
  const list = Array.isArray(entries) ? entries : [];
  if (!list.length) return "-";

  return (
    <div className="olympic-status-tl-cell">
      {list.map((entry, index) => (
        <div key={`${entry.name}-${index}`} className="olympic-status-tl-entry">
          <span className="olympic-status-tl-name">{entry.name}</span>
          {entry.indicator === "green" && (
            <span className="olympic-status-tl-tick olympic-status-tl-tick--match" aria-hidden="true">
              <FontAwesomeIcon icon={faCheck} />
            </span>
          )}
          {entry.indicator === "red" && (
            <span className="olympic-status-tl-tick olympic-status-tl-tick--mismatch" aria-hidden="true">
              <FontAwesomeIcon icon={faCheck} />
            </span>
          )}
        </div>
      ))}
    </div>
  );
}

export default OlympicStatusTeamLeaderCell;
